var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
export function getProgress(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/progress/${id}`);
    });
}
// A fresh opaque id for one job run. crypto.randomUUID where available, else a
// timestamp+random fallback (only needs to be unique within this browser session).
export function newProgressId() {
    const c = globalThis.crypto;
    if (c === null || c === void 0 ? void 0 : c.randomUUID)
        return c.randomUUID();
    return `pg-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}
